export const groupBy = <T extends Record<string, string> = Record<string, string>>({
  arrayHash,
  groupOn,
}: {
  arrayHash: T[]
  groupOn: string
}): Record<string, T[]> =>
  arrayHash.reduce(
    (collection, hashData) => {
      // eslint-disable-next-line no-param-reassign
      ;(collection[hashData[groupOn]] = collection[hashData[groupOn]] || []).push(hashData)
      return collection
    },
    {} as Record<string, T[]>,
  )
